import { ICompany } from "./../../../../interfaces/company";
import { MatCheckboxChange, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ICourseType } from "src/app/interfaces/course-type";
import { ErrorsService } from "src/app/services/common/errors.service";
import { CourseTypeService } from "./../../../../services/http/business/course-type/course-type.service";
import { ParrentTermService } from "src/app/services/http/business/parrent-term/parrent-term-service.service";
import { IYearList } from "src/app/interfaces/calendar-yearList";
import { ITermInfo } from "src/app/interfaces/term-info";
import * as moment from "jalali-moment";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-term-info-search',
  templateUrl: './term-info-search.component.html',
  styleUrls: ['./term-info-search.component.css']
})
export class TermInfoSearchComponent implements OnInit {
  param: any;
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  valError: boolean;
  yearList: IYearList;
  errors = new Array();
  companyList: ICompany;
  companySelected: string;
  courseTypeList: ICourseType[];
  parrentTermList: IParentTerm[];

  constructor(
    private fb: FormBuilder,
    // private dialog: MatDialog,
    private cidService: CIDService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private comapnyService: CompanyService,
    private calendatService: CalendarService,
    private courseTypeService: CourseTypeService,
    private parrentTermService: ParrentTermService,
    private dialogRef: MatDialogRef<TermInfoSearchComponent>,

    @Inject(MAT_DIALOG_DATA) public data: ITermInfo
  ) { }

  ngOnInit() {
    this.getYear();
    this.createForm();
    this.checkOwner();

    this.getParrentTermList();
    this.companySelected = this.isOwner ? null : this.cidService.getCID();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getComapnyList();
        if (this.data)
          this.getCourseType();
      }
      else {
        this.getCourseType();
        this.form.controls[""].patchValue(this.cidService.getCID())
      }
    });
  }

  getComapnyList() {
    this.comapnyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCid(e: any) {
    this.cidService.setCID(e);
    this.getParrentTermList();
    this.getCourseType();
  }

  createForm() {
    this.form = this.fb.group({
      company: [null],
      ParentTermId: [
        this.data && this.data.ParentTermId ? this.data.ParentTermId : null
      ],
      TermNumber: [
        this.data && this.data.TermNumber ? this.data.TermNumber : null,
        Validators.compose([
          Validators.min(1),
          Validators.max(32767)
        ])
      ],
      Title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([Validators.maxLength(50)])
      ],

      StartDate: [
        this.data && this.data.StartDate ? this.data.StartDate : null
      ],
      EndDate: [
        this.data && this.data.EndDate ? this.data.EndDate : null
      ],
      CourseTypeId: [
        this.data && this.data.CourseTypeId ? this.data.CourseTypeId : null
      ]
    });
  }

  getParrentTermList() {
    this.parrentTermService.list(0, 0).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  genTitle(event: MatCheckboxChange, title) {
    if (event.checked) {
      if (this.form.controls['Title'].value)
        this.form.controls['Title'].patchValue(this.form.controls['Title'].value + title + ' ');
      else
        this.form.controls['Title'].patchValue(title + ' ');
    }
    else
      this.form.controls['Title'].patchValue(this.form.controls['Title'].value.replace(title + ' ', ''));
  }

  getCourseType() {
    this.courseTypeService.list(0, 0).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  getYear() {
    this.calendatService.yearList().subscribe(res => {
      this.yearList = res;
    });
  }

  submit(data: ITermInfo) {
    this.errors = new Array();
    
    data.StartDate = moment
      .from(data.StartDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    data.EndDate = moment
      .from(data.EndDate, "en")
      .utc(true)
      .format(environment.dateFormat);

      this.dialogRef.close(data);
  }

  onNoClick() {
    this.dialogRef.close();
  }
}

